import React, { useState } from "react";
import VehicleConfigService from "../../services/VehicleConfigService";
import CFAdminModal from "../../components/CFAdminModal";
import CFAdminDataTable from "../../components/CFAdminDataTable";
import './CFAdminDecodeVin.scss';

const StatusCell = ({ value }: any) => (
    <span style={{ color: value === 'None' ? 'green' : 'red' }}>
        {value === 'None' ? 'Success' : value}
    </span>
);

const ShowDetailsCell = ({ row, column }: any) => (
    <button onClick={() => column.onShowDetails(row.original)}>
        Show Details
    </button>
);

interface VinData {
    vin1: string;
    errorMessage1: string;
    make1: string;
    model1: string;
    year1: string;
    restraintsDriver1: string;
    cab1: string;
    transmission1: string;
    vehicleType1: string;
    engineDisplacement1: string;
    brakesWeightRatingGVWR1: string;
    series1: string;
    assemblyCountry1: string;
    axleWheelbase1: string;
    engineManufacturer1: string;
    assemblyPlant1: string;
    bodyStyle1: string;
    fuel1: string;
    brakesPower1: string;
    driveTrain1: string;
    cylinders1: string;
}

function CFAdminDecodeVin() {
    const [vins, setVins] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [data, setData] = useState<VinData[]>([]);
    const [showTable, setShowTable] = useState(false);
    const [selectedRow, setSelectedRow] = useState<VinData | null>(null);

    const toggleModal = () => {
        setIsOpen(!isOpen);
    }

    const handleTextareaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setVins(event.target.value);
    };

    const resetForm = () => {
        setVins('');
        setShowTable(false);
    };

    const decodeVin = async () => {
        let vin = vins.split("\n");
        VehicleConfigService.decodeTestVin({ vin })
            .then(response => {
                const extractedData = response.data.decodeAttributes.map((item: { vin: any; errorMessage: any; attributeMap: { [key: string]: { attributeValue: any; }; }; }) => ({
                    vin1: item.vin,
                    errorMessage1: item.errorMessage,
                    make1: item.attributeMap?.Make?.attributeValue,
                    model1: item.attributeMap?.Model?.attributeValue,
                    year1: item.attributeMap?.Year?.attributeValue,
                    restraintsDriver1: item.attributeMap?.RestraintsDriver?.attributeValue,
                    cab1: item.attributeMap?.Cab?.attributeValue,
                    transmission1: item.attributeMap?.Transmission?.attributeValue,
                    vehicleType1: item.attributeMap?.VehicleType?.attributeValue,
                    engineDisplacement1: item.attributeMap?.EngineDisplacement?.attributeValue,
                    brakesWeightRatingGVWR1: item.attributeMap?.BrakesWeightRatingGVWR?.attributeValue,
                    series1: item.attributeMap?.Series?.attributeValue,
                    assemblyCountry1: item.attributeMap?.AssemblyCountry?.attributeValue,
                    axleWheelbase1: item.attributeMap?.AxleWheelbase?.attributeValue,
                    engineManufacturer1: item.attributeMap?.EngineManufacturer?.attributeValue,
                    assemblyPlant1: item.attributeMap?.AssemblyPlant?.attributeValue,
                    bodyStyle1: item.attributeMap?.BodyStyle?.attributeValue,
                    fuel1: item.attributeMap?.Fuel?.attributeValue,
                    brakesPower1: item.attributeMap?.BrakesPower?.attributeValue,
                    driveTrain1: item.attributeMap?.DriveTrain?.attributeValue,
                    cylinders1: item.attributeMap?.Cylinders?.attributeValue,
                }));
                setData(extractedData);
                setShowTable(true);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const openModal = (row: VinData) => {
        setSelectedRow(row);
        setIsOpen(true);
    };

    const closeModal = () => {
        setSelectedRow(null);
        setIsOpen(false);
    };

    const columns = [
        {
            Header: "VIN",
            accessor: 'vin1'
        },
        {
            Header: "Status",
            accessor: 'errorMessage1',
            Cell: StatusCell
        },
        {
            Header: "Make",
            accessor: 'make1'
        },
        {
            Header: "Model",
            accessor: 'model1'
        },
        {
            Header: "Year",
            accessor: 'year1'
        },
        {
            Header: "Actions",
            onShowDetails: openModal,
            Cell: ShowDetailsCell
        }
    ];

    const downloadCSV = () => {
        const csvRows = [
            ["VIN", "Status", "Make", "Model", "Year"],
            ...data.map(row => [row.vin1,
                row.errorMessage1, row.make1, row.model1, row.year1])
        ];

        const csvContent1 = csvRows.map(e => e.join(",")).join("\n");
        const blob1 = new Blob([csvContent1], { type: 'text/csv;charset=utf-8;' });
        const link1 = document.createElement("a");
        const url1 = URL.createObjectURL(blob1);
        link1.setAttribute("href", url1);
        link1.setAttribute("download", "vin_decode_results.csv");
        link1.style.visibility = 'hidden';
        document.body.appendChild(link1);
        link1.click();
        document.body.removeChild(link1);
    };

    return (
        <>
            <div className="vinimport-component">
                <h2 className="fomo-type--title">Decode VIN</h2>
                <div className="ext3">
                    Please enter the VINs that need to be validated, then click on 'Decode VIN.'
                </div>
                {!showTable && (
                    <textarea
                        rows={50}
                        style={{width: "25%", height: "500px", overflowY: "scroll"}}
                        value={vins}
                        onChange={handleTextareaChange}
                    />
                )}
                {showTable && (
                    <div className="modal-content-vin">
                        <div style={{width: "75%", overflowX: "auto"}}>
                            <CFAdminDataTable
                                columns={columns}
                                data={data}
                                toggleModal={toggleModal}
                                textModal={''}
                                showAdd={false}
                            />
                        </div>
                    </div>
                )}
                <div className="modal-footer button-frame">
                    <button data-testid="step-cancel" className="fvp-button--outline fvp-button"
                            type="submit"
                            onClick={resetForm}>
                        <i className="fvp-left-chevron"/>Cancel
                    </button>
                    <div className="right-align">
                        {!showTable && (
                            <button
                                data-testid="step-release-vin"
                                className="fvp-button button-right-align"
                                type="button"
                                onClick={decodeVin}
                            >
                                Decode VIN
                            </button>
                        )}
                    </div>
                    {showTable && (
                        <button
                            className="fvp-button button-right-align"
                            type="button"
                            onClick={downloadCSV}
                        >
                            Download CSV
                        </button>
                    )}
                </div>
            </div>
            {selectedRow && (
                <CFAdminModal
                    isOpen={isOpen}
                    toggle={toggleModal}
                    isAdd={false}
                    title={'Vin Decode Results'}
                >
                    <div className="table-container">
                        <table className="table-details">
                            <tbody>
                            <tr>
                                <th>Make</th>
                                <td>{selectedRow.make1}</td>
                            </tr>
                            <tr>
                                <th>Model</th>
                                <td>{selectedRow.model1}</td>
                            </tr>
                            <tr>
                                <th>Year</th>
                                <td>{selectedRow.year1}</td>
                            </tr>
                            <tr>
                                <th>Restraints Driver</th>
                                <td>{selectedRow.restraintsDriver1}</td>
                            </tr>
                            <tr>
                                <th>Cab</th>
                                <td>{selectedRow.cab1}</td>
                            </tr>
                            <tr>
                                <th>Transmission</th>
                                <td>{selectedRow.transmission1}</td>
                            </tr>
                            <tr>
                                <th>Vehicle Type</th>
                                <td>{selectedRow.vehicleType1}</td>
                            </tr>
                            <tr>
                                <th>Engine Displacement</th>
                                <td>{selectedRow.engineDisplacement1}</td>
                            </tr>
                            <tr>
                                <th>Brakes Weight Rating GVWR</th>
                                <td>{selectedRow.brakesWeightRatingGVWR1}</td>
                            </tr>
                            <tr>
                                <th>Series</th>
                                <td>{selectedRow.series1}</td>
                            </tr>
                            <tr>
                                <th>Assembly Country</th>
                                <td>{selectedRow.assemblyCountry1}</td>
                            </tr>
                            <tr>
                                <th>Axle Wheelbase</th>
                                <td>{selectedRow.axleWheelbase1}</td>
                            </tr>
                            <tr>
                                <th>Engine Manufacturer</th>
                                <td>{selectedRow.engineManufacturer1}</td>
                            </tr>
                            <tr>
                                <th>Assembly Plant</th>
                                <td>{selectedRow.assemblyPlant1}</td>
                            </tr>
                            <tr>
                                <th>Body Style</th>
                                <td>{selectedRow.bodyStyle1}</td>
                            </tr>
                            <tr>
                                <th>Fuel</th>
                                <td>{selectedRow.fuel1}</td>
                            </tr>
                            <tr>
                                <th>Brakes Power</th>
                                <td>{selectedRow.brakesPower1}</td>
                            </tr>
                            <tr>
                                <th>Drive Train</th>
                                <td>{selectedRow.driveTrain1}</td>
                            </tr>
                            <tr>
                                <th>Cylinders</th>
                                <td>{selectedRow.cylinders1}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <button onClick={closeModal}>Close</button>
                </CFAdminModal>
            )
            }
        </>
    )
        ;
}

export default CFAdminDecodeVin;